import { useCallback, useEffect } from 'react'

import { useSelector } from 'react-redux'

import { BridgeService } from '@services/bridge'
import Tag from '@utils/Tag'
import { validaEnvHomeByBridge } from '@utils/functions'
import { ApplicationState } from '@store/types'

const FEEDBACK_BASE = {
  screen: 'clt:refin:feedback',
  section: 'feedback',
  sub_section: '',
  step: '',
  scenario: 'blocked',
  ref_figma: '2',
} as const

const WEB_FEEDBACK_BASE = {
  section_name: 'payrollloan:refin:feedback',
  section: 'feedback',
  sub_section: '',
  step: '',
  scenario: 'blocked',
} as const

const sendPageLoadTracking = (isApp: boolean, actionId: string, elementName: string) => {
  if (isApp) {
    Tag.enviarTagueamentoApp({
      ...FEEDBACK_BASE,
      ref_type: '',
      content_action: 'Dado carregado',
      action_id: actionId,
    })
    return
  }

  Tag.enviarTagueamentoWeb({
    ...WEB_FEEDBACK_BASE,
    element_action: 'page_loaded',
    element_name: elementName,
    c_page: window.location.href,
    redirect_url: '',
  })
}

const sendButtonClickTracking = (isApp: boolean, actionId: string, redirectUrl: string) => {
  if (isApp) {
    Tag.enviarTagueamentoApp({
      ...FEEDBACK_BASE,
      ref_type: 'botao',
      content_action: 'Toque',
      action_id: actionId,
    })
    return
  }

  Tag.enviarTagueamentoWeb({
    ...WEB_FEEDBACK_BASE,
    element_action: 'click button',
    element_name: actionId,
    c_page: window.location.href,
    redirect_url: redirectUrl,
  })
}

const useFeedbackPageTracking = (actionId: string, elementName: string) => {
  const isApp = useSelector((state: ApplicationState) => state.ui.navigation.isApp)

  useEffect(() => {
    sendPageLoadTracking(isApp, actionId, elementName)
  }, [isApp, actionId, elementName])
}

const useGoHomeButton = (ticName: string, actionId = 'Ir para a home'): (() => void) => {
  const { isApp, origemGoBack } = useSelector((state: ApplicationState) => state.ui.navigation)

  return useCallback(() => {
    BridgeService.tic({
      name: ticName,
      action: 'voltar_para_home',
    })

    sendButtonClickTracking(
      isApp,
      actionId,
      validaEnvHomeByBridge(String(origemGoBack), isApp) || '',
    )

    window.location.href = validaEnvHomeByBridge(String(origemGoBack), isApp) || ''
  }, [ticName, actionId, isApp, origemGoBack])
}

export { useFeedbackPageTracking, useGoHomeButton, sendButtonClickTracking }
